import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { appRoutes } from "constants/appRoutes";
// Site
import SiteLayout from 'layouts/Site/SiteLayout';
import Home from 'containers/Home/Home';
import AboutUs from 'containers/AboutUs/AboutUs';
import Services from "containers/Services/Services";
import Products from "containers/Products/Products";
import ContactUs from 'containers/ContactUs/ContactUs';
// Account
import AccountLayout from 'layouts/Account/AccountLayout';
import Login from 'containers/account/Login/Login';
import Register from 'containers/account/Register/Register';
import Logout from 'containers/account/Logout/Logout';
import Unauthorized from 'containers/account/Unauthorized/Unauthorized';
// Admin
import AdminLayout from 'layouts/Admin/AdminLayout';
import Dashboard from 'containers/admin/Dashboard/Dashboard';
import UserList from 'containers/admin/User/UserList';
import UserForm from 'containers/admin/User/UserForm';
import UserDetails from 'containers/admin/User/UserDetails';
import CustomerList from 'containers/admin/Customer/CustomerList';
import CustomerForm from 'containers/admin/Customer/CustomerForm';
import CustomerDetails from 'containers/admin/Customer/CustomerDetails';
import CustomerInvoiceList from "containers/admin/Customer/CustomerInvoiceList";
import CustomerInvoiceForm from "containers/admin/Customer/CustomerInvoiceForm";
import InvoiceList from "containers/admin/Invoice/InvoiceList";
import InvoiceDetails from "containers/admin/Invoice/InvoiceDetails";
import CustomerInvoiceItemList from "containers/admin/Customer/CustomerInvoiceItemList";
import AuthProvider from "hooks/AuthProvider";

const App = () => {
  console.log(process.env);

  return (
    <AuthProvider>
      <Routes>
        {/* Site */}
        <Route path={appRoutes.path} element={<SiteLayout />}>
          <Route index element={<Home />} />
          <Route path={appRoutes.home} element={<Home />} />
          <Route path={appRoutes.aboutUs} element={<AboutUs />} />
          <Route path={appRoutes.services} element={<Services />} />
          <Route path={appRoutes.products} element={<Products />} />
          <Route path={appRoutes.contactUs} element={<ContactUs />} />
          {/* Account */}
          <Route path={appRoutes.account} element={<AccountLayout />}>
            <Route path={appRoutes.login} element={<Login />} />
            <Route path={appRoutes.register} element={<Register />} />
            <Route path={appRoutes.logout} element={<Logout />} />
            <Route path={appRoutes.unauthorized} element={<Unauthorized />} />
          </Route>
        </Route>
        {/* Admin */}
        {/* <Route path={appRoutes.admin} element={(token ? <AdminLayout /> : <Navigate to={appRoutes.login} />)}> */}
        <Route path={appRoutes.admin} element={<AdminLayout />}>
          <Route index element={<Navigate to={appRoutes.dashboard} />} />
          <Route path={appRoutes.dashboard} element={<Dashboard />} />
          {/* User */}
          <Route path={appRoutes.users} element={<UserList />} />
          <Route path={appRoutes.userAdd} element={<UserForm />} />
          <Route path={appRoutes.userEdit} element={<UserForm />} />
          <Route path={appRoutes.userView} element={<UserDetails />} />
          {/* Customer */}
          <Route path={appRoutes.customers} element={<CustomerList />} />
          <Route path={appRoutes.customerAdd} element={<CustomerForm />} />
          <Route path={appRoutes.customerEdit} element={<CustomerForm />} />
          <Route path={appRoutes.customerView} element={<CustomerDetails />} />
          <Route path={appRoutes.customerInvoices} element={<CustomerInvoiceList />} />
          <Route path={appRoutes.customerInvoiceAdd} element={<CustomerInvoiceForm />} />
          <Route path={appRoutes.customerInvoiceItems} element={<CustomerInvoiceItemList />} />
          {/* Invoice */}
          <Route path={appRoutes.invoices} element={<InvoiceList />} />
          <Route path={appRoutes.invoicedetails} element={<InvoiceDetails />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
